import React from 'react';

import { Action, Actions, ActionBar } from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenTitle } from '@gogame/screens';

export default ({ onCreate }) => {
  const [title] = useScreenTitle();

  return (
    <ActionBar
      title={title}
      search={<SearchField />}
      primaryActions={
        <Actions>
          <Action component={FullScreenToggler} />
          <Action
            border={true}
            button={true}
            add={true}
            iconContent={true}
            tooltip={'Add Brief'}
            variant={'outlined'}
            onClick={onCreate}
          />
        </Actions>
      }
    />
  );
};
